export default["__VITE_ASSET__ahoGcdWK__","__VITE_ASSET__8knq7IM$__"];